(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


var $59bdea93f29f00f1$var$nav = {
    hamburger: function() {
        var hamburger = document.querySelector('.nav-toggle');
        if (!hamburger) return;
        var container = document.querySelector('body');
        hamburger.addEventListener('click', function() {
            hamburger.classList.toggle('nav--toggled');
            container.classList.toggle('nav--toggled');
        });
    }
};
var $59bdea93f29f00f1$export$2e2bcd8739ae039 = $59bdea93f29f00f1$var$nav;


var $ad83677196d09d75$export$db3c28d99448dcff = {
    html: '<svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none"><rect width="54" height="54" x="1.5" y="1" fill="#14217E" rx="11"/>\n    <rect width="54" height="54" x="1.5" y="1" stroke="#fff" stroke-width="2" rx="11"/> <g fill="#fff" clip-path="url(#a)"><path fill-rule="evenodd" d="M12.5 28c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16Zm16-13.078c-7.223 0-13.078 5.855-13.078 13.078 0 7.222 5.855 13.078 13.078 13.078 7.223 0 13.078-5.856 13.078-13.078 0-7.223-5.855-13.078-13.078-13.078Z" clip-rule="evenodd"/><path d="M27.392 37.202h2.186v-3.843h-2.186v3.843Z"/><path fill-rule="evenodd" d="M29.578 20.665V18.88h-2.186v1.76H23.42v14.611h2.647v-5.35h2.693l2.871 5.35h2.954l-3.16-5.784c.095-.039.188-.08.278-.123.77-.376 1.353-.906 1.748-1.591.4-.69.599-1.503.599-2.44 0-.932-.198-1.748-.592-2.447-.39-.704-.968-1.25-1.734-1.641-.602-.309-1.318-.495-2.147-.56Zm-3.51 7.038h2.44c.656 0 1.193-.09 1.612-.271.418-.185.728-.454.927-.806.205-.357.307-.795.307-1.313 0-.518-.102-.96-.307-1.327a1.951 1.951 0 0 0-.934-.842c-.419-.195-.959-.292-1.62-.292h-2.425v4.851Z" clip-rule="evenodd"/>\n    </g><defs><clipPath id="a"><path fill="#fff" d="M12.5 12h32v32h-32z"/></clipPath></defs></svg>'
};


var $10edc3af817468b2$export$cddc5598d4bb8461 = {
    settings: {
        timelines: document.querySelectorAll('.is-style-is-timeline')
    },
    init: function() {
        this.setDOM();
        this.setEvents();
    },
    setDOM: function() {
        if (!this.settings.timelines) return;
        this.settings.timelines.forEach(function(timeline) {
            var scroller = document.createElement('div');
            var drag = document.createElement('div');
            scroller.classList.add('is-style-is-timeline__scroller', 'js-timeline-scroller');
            drag.classList.add('is-style-is-timeline__drag', 'js-timeline-drag');
            drag.innerHTML = (0, $ad83677196d09d75$export$db3c28d99448dcff).html;
            timeline.appendChild(scroller);
            scroller.appendChild(drag);
        });
    },
    setEvents: function() {
        var _this = this;
        if (!this.settings.timelines) return;
        var stickyOffset = 100;
        window.addEventListener('scroll', function() {
            _this.settings.timelines.forEach(function(timeline) {
                var scroller = timeline.querySelector('.js-timeline-scroller');
                var drag = timeline.querySelector('.js-timeline-drag');
                if (!scroller || !drag) return;
                var timelineRect = timeline.getBoundingClientRect();
                var availableScrollSpace = timeline.offsetHeight - drag.offsetHeight;
                var progress = 0;
                if (timelineRect.top <= stickyOffset) {
                    progress = Math.min(stickyOffset - timelineRect.top, availableScrollSpace);
                    progress = Math.max(0, progress);
                }
                if (isFinite(progress)) timeline.style.setProperty('--height', "".concat(progress, "px"));
            });
        }, {
            passive: true
        });
    }
};


var $ff6ae1802822eacd$export$b9a48885095f3eee = {
    settings: {
        carouselContainer: null,
        touchStartX: 0,
        touchEndX: 0,
        isDragging: false,
        dragStartX: 0,
        dragEndX: 0,
        nextButton: null,
        prevButton: null
    },
    init: function() {
        var container = document.querySelector(".brtpmj-carousel-container");
        if (!container) return;
        this.settings.carouselContainer = container;
        this.settings.nextButton = container.querySelector(".brtpmj-slider-next");
        this.settings.prevButton = container.querySelector(".brtpmj-slider-prev");
        this.setAccessibilityAttributes();
        this.setEventListeners();
    },
    setAccessibilityAttributes: function() {
        var _this_settings = this.settings, carouselContainer = _this_settings.carouselContainer, nextButton = _this_settings.nextButton, prevButton = _this_settings.prevButton;
        carouselContainer.setAttribute("role", "region");
        carouselContainer.setAttribute("aria-label", "User reviews carousel");
        prevButton.setAttribute("aria-label", "Previous review");
        prevButton.setAttribute("tabindex", "0");
        nextButton.setAttribute("aria-label", "Next review");
        nextButton.setAttribute("tabindex", "0");
    },
    setEventListeners: function() {
        var _this = this;
        var _this_settings = this.settings, carouselContainer = _this_settings.carouselContainer, nextButton = _this_settings.nextButton, prevButton = _this_settings.prevButton;
        carouselContainer.addEventListener("touchstart", function(event) {
            _this.settings.touchStartX = event.changedTouches[0].screenX;
        });
        carouselContainer.addEventListener("touchend", function(event) {
            _this.settings.touchEndX = event.changedTouches[0].screenX;
            _this.handleSwipeGesture();
        });
        carouselContainer.addEventListener("mousedown", function(event) {
            _this.settings.isDragging = true;
            _this.settings.dragStartX = event.screenX;
            carouselContainer.classList.add("dragging");
        });
        carouselContainer.addEventListener("mousemove", function(event) {
            if (_this.settings.isDragging) _this.settings.dragEndX = event.screenX;
        });
        carouselContainer.addEventListener("mouseup", function() {
            if (!_this.settings.isDragging) return;
            _this.settings.isDragging = false;
            carouselContainer.classList.remove("dragging");
            _this.handleDragGesture();
        });
        carouselContainer.addEventListener("mouseleave", function() {
            _this.settings.isDragging = false;
            carouselContainer.classList.remove("dragging");
        });
        document.addEventListener("keydown", function(event) {
            var activeElement = document.activeElement;
            var isCarouselFocused = carouselContainer.contains(activeElement);
            var isButtonFocused = activeElement === nextButton || activeElement === prevButton;
            if (isCarouselFocused || isButtonFocused) {
                if (event.key === "ArrowRight") nextButton.click();
                if (event.key === "ArrowLeft") prevButton.click();
            }
        });
    },
    handleSwipeGesture: function() {
        var distance = this.settings.touchEndX - this.settings.touchStartX;
        if (distance < -50) this.settings.nextButton.click();
        if (distance > 50) this.settings.prevButton.click();
    },
    handleDragGesture: function() {
        var distance = this.settings.dragEndX - this.settings.dragStartX;
        if (distance < -50) this.settings.nextButton.click();
        if (distance > 50) this.settings.prevButton.click();
    }
};


var $dedf1145ddd36956$var$Newsletter = {
    loading: false,
    init: function() {
        $dedf1145ddd36956$var$Newsletter.initNewsletterForm();
    },
    initNewsletterForm: function() {
        var forms = document.querySelectorAll("[data-newsletter-form]");
        forms.forEach(function(form) {
            var button = form.querySelector('[type="submit"]');
            form.addEventListener('submit', function(ev) {
                ev.preventDefault();
                if ($dedf1145ddd36956$var$Newsletter.loading) return false;
                $dedf1145ddd36956$var$Newsletter.loading = true;
                var data = new FormData();
                data.append('email', form.querySelector('[name="user_email"]').value);
                data.append('group', form.querySelector('[name="group"]').value);
                data.append('nonce', ajax_var.ajax_nonce);
                data.append('action', 'register_newsletter_subscriber');
                form.classList.toggle('loading', $dedf1145ddd36956$var$Newsletter.loading);
                button === null || button === void 0 ? void 0 : button.classList.toggle('button-loading', $dedf1145ddd36956$var$Newsletter.loading);
                var responseMessage = form.querySelector('[data-newsletter-response]');
                responseMessage.classList.remove('visible', 'error');
                fetch(form.action, {
                    method: 'post',
                    body: data
                }).then(function(response) {
                    return response.json();
                }).then(function(response) {
                    if (response.success) {
                        responseMessage.innerText = responseMessage.getAttribute('data-newsletter-response');
                        return;
                    }
                    responseMessage.classList.add('error');
                    responseMessage.innerText = responseMessage.getAttribute('data-newsletter-response-error');
                }).catch(function(reason) {
                    console.warn(reason);
                    responseMessage.classList.add('error');
                    responseMessage.innerText = responseMessage.getAttribute('data-newsletter-response-error');
                }).finally(function() {
                    $dedf1145ddd36956$var$Newsletter.loading = false;
                    form.classList.toggle('loading', $dedf1145ddd36956$var$Newsletter.loading);
                    button === null || button === void 0 ? void 0 : button.classList.toggle('button-loading', $dedf1145ddd36956$var$Newsletter.loading);
                    responseMessage.classList.add('visible');
                    form.reset();
                });
                return false;
            });
        });
    }
};
var $dedf1145ddd36956$export$2e2bcd8739ae039 = $dedf1145ddd36956$var$Newsletter;


var $847553d13b80c4b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function App() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, App);
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(App, [
        {
            key: "initCore",
            value: function initCore() {
                (0, $59bdea93f29f00f1$export$2e2bcd8739ae039).hamburger();
                (0, $10edc3af817468b2$export$cddc5598d4bb8461).init();
                (0, $ff6ae1802822eacd$export$b9a48885095f3eee).init();
                (0, $dedf1145ddd36956$export$2e2bcd8739ae039).init();
            }
        }
    ]);
    return App;
}();
function $847553d13b80c4b3$var$LoadApp() {
    var app = new $847553d13b80c4b3$export$2e2bcd8739ae039();
    app.initCore();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $847553d13b80c4b3$var$LoadApp);
else $847553d13b80c4b3$var$LoadApp();

})();
//# sourceMappingURL=_app.js.map
